module.exports = __webpack_public_path__ + "img/corp-customization-side.e9373057.svg";